/* eslint-disable react/prefer-stateless-function */
import React, { Component, Fragment } from "react";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import ResetToDefaultProps from "editor/components/ResetToDefaultProps";
import PropsPopover from "editor/components/PropsPopover";
import { I18n } from "react-redux-i18n";
import { PropListItem, PropLabel, ActiveLabel } from "../styles";
import BackgroundPopover from "./BackgroundPopover";

const FlexContainer = styled.div`
  display: flex;
`;

class BackgroundEffect extends Component {
  render() {
    const { label, locale, tooltip, name, updaterFn, currentValue } =
      this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;
    const enabled = currentValue && currentValue.activateEffect;
    return (
      <PropListItem>
        <PropLabel style={{display: 'flex', alignItems: 'baseline', gap: '4px'}}>
          <EditorLabel tooptip={tooltipText}>{label[locale]}</EditorLabel>
          <ActiveLabel active={enabled}>{I18n.t(enabled ? 'editPanel.active' : 'editPanel.disabled')}</ActiveLabel>
        </PropLabel>
        <FlexContainer>
          <ResetToDefaultProps
            name={name}
            defaultProps={null}
            updaterFn={updaterFn}
          />
          <PropsPopover>
            <Fragment>
              <BackgroundPopover {...this.props} />
            </Fragment>
          </PropsPopover>
        </FlexContainer>
      </PropListItem>
    );
  }
}

export default BackgroundEffect;
